/* eslint-disable */
import { PluginContainerData } from './common';
import { MapType } from './plugin_map.enums';
export function mapTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'ROADMAP':
            return MapType.ROADMAP;
        case 1:
        case 'SATELITE':
            return MapType.SATELITE;
        case 2:
        case 'HYBRID':
            return MapType.HYBRID;
        case 3:
        case 'TERRAIN':
            return MapType.TERRAIN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MapType.UNRECOGNIZED;
    }
}
export function mapTypeToJSON(object) {
    switch (object) {
        case MapType.ROADMAP:
            return 'ROADMAP';
        case MapType.SATELITE:
            return 'SATELITE';
        case MapType.HYBRID:
            return 'HYBRID';
        case MapType.TERRAIN:
            return 'TERRAIN';
        default:
            return 'UNKNOWN';
    }
}
const baseMapData = {};
export const MapData = {
    fromJSON(object) {
        const message = Object.assign({}, baseMapData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.mapSettings =
            object.mapSettings !== undefined && object.mapSettings !== null
                ? MapSettings.fromJSON(object.mapSettings)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.mapSettings !== undefined &&
            (obj.mapSettings = message.mapSettings ? MapSettings.toJSON(message.mapSettings) : undefined);
        return obj;
    },
};
const baseMapSettings = { mapType: MapType.ROADMAP };
export const MapSettings = {
    fromJSON(object) {
        const message = Object.assign({}, baseMapSettings);
        message.address =
            object.address !== undefined && object.address !== null ? String(object.address) : undefined;
        message.draggable =
            object.draggable !== undefined && object.draggable !== null
                ? Boolean(object.draggable)
                : undefined;
        message.marker =
            object.marker !== undefined && object.marker !== null ? Boolean(object.marker) : undefined;
        message.streetViewControl =
            object.streetViewControl !== undefined && object.streetViewControl !== null
                ? Boolean(object.streetViewControl)
                : undefined;
        message.zoomControl =
            object.zoomControl !== undefined && object.zoomControl !== null
                ? Boolean(object.zoomControl)
                : undefined;
        message.lat = object.lat !== undefined && object.lat !== null ? Number(object.lat) : undefined;
        message.lng = object.lng !== undefined && object.lng !== null ? Number(object.lng) : undefined;
        message.locationName =
            object.locationName !== undefined && object.locationName !== null
                ? String(object.locationName)
                : undefined;
        message.viewModeControl =
            object.viewModeControl !== undefined && object.viewModeControl !== null
                ? Boolean(object.viewModeControl)
                : undefined;
        message.initialZoom =
            object.initialZoom !== undefined && object.initialZoom !== null
                ? Number(object.initialZoom)
                : undefined;
        message.mapType =
            object.mapType !== undefined && object.mapType !== null
                ? mapTypeFromJSON(object.mapType)
                : MapType.ROADMAP;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.draggable !== undefined && (obj.draggable = message.draggable);
        message.marker !== undefined && (obj.marker = message.marker);
        message.streetViewControl !== undefined && (obj.streetViewControl = message.streetViewControl);
        message.zoomControl !== undefined && (obj.zoomControl = message.zoomControl);
        message.lat !== undefined && (obj.lat = message.lat);
        message.lng !== undefined && (obj.lng = message.lng);
        message.locationName !== undefined && (obj.locationName = message.locationName);
        message.viewModeControl !== undefined && (obj.viewModeControl = message.viewModeControl);
        message.initialZoom !== undefined && (obj.initialZoom = message.initialZoom);
        message.mapType !== undefined && (obj.mapType = mapTypeToJSON(message.mapType));
        return obj;
    },
};
//# sourceMappingURL=plugin_map.js.map